import { useConfig } from '../../providers/config'

export const useWhatsApp = () => {
	const {
		whatsapp: { number, prefilled },
	} = useConfig()

	const waLink = number ? `https://wa.me/${number}${prefilled ? `?text=${encodeURIComponent(prefilled)}` : ''}` : null

	return waLink
}
